// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upskld_course_pg_wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f6f3ec;
  box-sizing: border-box;
  font-family: 'Manrope', sans-serif;
  padding: 56px 24px 72px;
}

.upskld_course_pg_header {
  max-width: 640px;
  margin: 0 auto 40px;
  text-align: center;
}

.upskld_course_pg_heading {
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 800;
  letter-spacing: -0.3px;
  color: #241f16;
  margin: 0 0 10px;
}

.upskld_course_pg_subheading {
  font-size: 14px;
  font-weight: 500;
  color: #8a8478;
  margin: 0;
  line-height: 1.6;
}

.upskld_course_pg_grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 26px;
  max-width: 1200px;
  margin: 0 auto;
}

.upskld_course_pg_card {
  position: relative;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 4px 14px rgba(28, 27, 20, 0.06);
  overflow: hidden;
  animation: upskld_course_pg_popIn 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  will-change: transform;
}

.upskld_course_pg_card:nth-child(1) { animation-delay: 0.05s; }
.upskld_course_pg_card:nth-child(2) { animation-delay: 0.12s; }
.upskld_course_pg_card:nth-child(3) { animation-delay: 0.19s; }
.upskld_course_pg_card:nth-child(4) { animation-delay: 0.26s; }
.upskld_course_pg_card:nth-child(5) { animation-delay: 0.33s; }

@keyframes upskld_course_pg_popIn {
  from { opacity: 0; transform: scale(0.92) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.upskld_course_pg_card:not(.upskld_course_pg_card_locked):hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 32px rgba(28, 27, 20, 0.12);
}

.upskld_course_pg_card_inner {
  display: flex;
  flex-direction: column;
  padding: 20px 20px 24px;
  transition: filter 0.4s ease, opacity 0.4s ease;
}

.upskld_course_pg_card_locked .upskld_course_pg_card_inner {
  filter: blur(2.5px) grayscale(35%);
  opacity: 0.55;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.upskld_course_pg_image_wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  background: #ffe3d1;
}

.upskld_course_pg_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upskld_course_pg_done_badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #34c795;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.3px;
  padding: 5px 10px;
  border-radius: 100px;
}

.upskld_course_pg_card_title {
  font-size: 15.5px;
  font-weight: 800;
  color: #241f16;
  margin: 0 0 8px;
  letter-spacing: -0.1px;
}

.upskld_course_pg_card_desc {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.6;
  color: #8a8478;
  margin: 0 0 20px;
  flex: 1 1;
}

.upskld_course_pg_watch_btn {
  font-family: 'Manrope', sans-serif;
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ff8a5c;
  color: #ffffff;
  border: none;
  border-radius: 100px;
  padding: 11px 22px;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, background 0.25s ease;
  will-change: transform;
}

.upskld_course_pg_watch_btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transform: skewX(-20deg);
  transition: left 0.6s ease;
}

.upskld_course_pg_watch_btn:hover {
  background: #241f16;
  box-shadow: 0 10px 22px rgba(36, 31, 22, 0.22);
  transform: translateY(-3px) scale(1.03);
}

.upskld_course_pg_watch_btn:hover::before {
  left: 120%;
}

.upskld_course_pg_watch_btn:active {
  transform: translateY(0) scale(0.98);
}

.upskld_course_pg_watch_arrow {
  display: inline-block;
  transition: transform 0.25s ease;
}

.upskld_course_pg_watch_btn:hover .upskld_course_pg_watch_arrow {
  transform: translateX(4px);
}

.upskld_course_pg_lock_overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  pointer-events: none;
}

.upskld_course_pg_lock_icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(36, 31, 22, 0.82);
  color: #ffffff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: upskld_course_pg_lockPulse 2.6s ease-in-out infinite;
}

@keyframes upskld_course_pg_lockPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
}

.upskld_course_pg_upcoming_badge {
  background: #241f16;
  color: #ffffff;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.6px;
  padding: 5px 12px;
  border-radius: 100px;
}

/* ---------- RESPONSIVE ---------- */

@media (max-width: 900px) {
  .upskld_course_pg_grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 640px) {
  .upskld_course_pg_wrapper {
    padding: 44px 18px 56px;
  }

  .upskld_course_pg_grid {
    grid-template-columns: 1fr;
    max-width: 420px;
  }
}

@media (max-width: 380px) {
  .upskld_course_pg_card_inner {
    padding: 16px 16px 20px;
  }

  .upskld_course_pg_watch_btn {
    width: 100%;
    justify-content: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .upskld_course_pg_card {
    animation: none;
  }
  .upskld_course_pg_lock_icon,
  .upskld_course_pg_watch_btn::before {
    animation: none;
    transition: none;
  }
}

.upskld_course_pg_loading {
  text-align: center;
  font-size: 13.5px;
  font-weight: 600;
  color: #8a8478;
  padding: 40px 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/CoursePage/CoursePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA,sCAAsC,sBAAsB,EAAE;AAC9D,sCAAsC,sBAAsB,EAAE;AAC9D,sCAAsC,sBAAsB,EAAE;AAC9D,sCAAsC,sBAAsB,EAAE;AAC9D,sCAAsC,sBAAsB,EAAE;;AAE9D;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2GAA2G;EAC3G,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,uFAAuF;EACvF,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+DAA+D;AACjE;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qCAAqC;;AAErC;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".upskld_course_pg_wrapper {\n  width: 100%;\n  min-height: 100vh;\n  background: #f6f3ec;\n  box-sizing: border-box;\n  font-family: 'Manrope', sans-serif;\n  padding: 56px 24px 72px;\n}\n\n.upskld_course_pg_header {\n  max-width: 640px;\n  margin: 0 auto 40px;\n  text-align: center;\n}\n\n.upskld_course_pg_heading {\n  font-size: clamp(22px, 3vw, 30px);\n  font-weight: 800;\n  letter-spacing: -0.3px;\n  color: #241f16;\n  margin: 0 0 10px;\n}\n\n.upskld_course_pg_subheading {\n  font-size: 14px;\n  font-weight: 500;\n  color: #8a8478;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.upskld_course_pg_grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 26px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.upskld_course_pg_card {\n  position: relative;\n  background: #ffffff;\n  border-radius: 18px;\n  box-shadow: 0 4px 14px rgba(28, 27, 20, 0.06);\n  overflow: hidden;\n  animation: upskld_course_pg_popIn 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n  will-change: transform;\n}\n\n.upskld_course_pg_card:nth-child(1) { animation-delay: 0.05s; }\n.upskld_course_pg_card:nth-child(2) { animation-delay: 0.12s; }\n.upskld_course_pg_card:nth-child(3) { animation-delay: 0.19s; }\n.upskld_course_pg_card:nth-child(4) { animation-delay: 0.26s; }\n.upskld_course_pg_card:nth-child(5) { animation-delay: 0.33s; }\n\n@keyframes upskld_course_pg_popIn {\n  from { opacity: 0; transform: scale(0.92) translateY(20px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.upskld_course_pg_card:not(.upskld_course_pg_card_locked):hover {\n  transform: translateY(-6px);\n  box-shadow: 0 16px 32px rgba(28, 27, 20, 0.12);\n}\n\n.upskld_course_pg_card_inner {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 24px;\n  transition: filter 0.4s ease, opacity 0.4s ease;\n}\n\n.upskld_course_pg_card_locked .upskld_course_pg_card_inner {\n  filter: blur(2.5px) grayscale(35%);\n  opacity: 0.55;\n  pointer-events: none;\n  user-select: none;\n}\n\n.upskld_course_pg_image_wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 16px;\n  background: #ffe3d1;\n}\n\n.upskld_course_pg_image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.upskld_course_pg_done_badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: #34c795;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  padding: 5px 10px;\n  border-radius: 100px;\n}\n\n.upskld_course_pg_card_title {\n  font-size: 15.5px;\n  font-weight: 800;\n  color: #241f16;\n  margin: 0 0 8px;\n  letter-spacing: -0.1px;\n}\n\n.upskld_course_pg_card_desc {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.6;\n  color: #8a8478;\n  margin: 0 0 20px;\n  flex: 1;\n}\n\n.upskld_course_pg_watch_btn {\n  font-family: 'Manrope', sans-serif;\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #ff8a5c;\n  color: #ffffff;\n  border: none;\n  border-radius: 100px;\n  padding: 11px 22px;\n  font-size: 12.5px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, background 0.25s ease;\n  will-change: transform;\n}\n\n.upskld_course_pg_watch_btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n  transform: skewX(-20deg);\n  transition: left 0.6s ease;\n}\n\n.upskld_course_pg_watch_btn:hover {\n  background: #241f16;\n  box-shadow: 0 10px 22px rgba(36, 31, 22, 0.22);\n  transform: translateY(-3px) scale(1.03);\n}\n\n.upskld_course_pg_watch_btn:hover::before {\n  left: 120%;\n}\n\n.upskld_course_pg_watch_btn:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.upskld_course_pg_watch_arrow {\n  display: inline-block;\n  transition: transform 0.25s ease;\n}\n\n.upskld_course_pg_watch_btn:hover .upskld_course_pg_watch_arrow {\n  transform: translateX(4px);\n}\n\n.upskld_course_pg_lock_overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  pointer-events: none;\n}\n\n.upskld_course_pg_lock_icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(36, 31, 22, 0.82);\n  color: #ffffff;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: upskld_course_pg_lockPulse 2.6s ease-in-out infinite;\n}\n\n@keyframes upskld_course_pg_lockPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.08); }\n}\n\n.upskld_course_pg_upcoming_badge {\n  background: #241f16;\n  color: #ffffff;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  padding: 5px 12px;\n  border-radius: 100px;\n}\n\n/* ---------- RESPONSIVE ---------- */\n\n@media (max-width: 900px) {\n  .upskld_course_pg_grid {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 20px;\n  }\n}\n\n@media (max-width: 640px) {\n  .upskld_course_pg_wrapper {\n    padding: 44px 18px 56px;\n  }\n\n  .upskld_course_pg_grid {\n    grid-template-columns: 1fr;\n    max-width: 420px;\n  }\n}\n\n@media (max-width: 380px) {\n  .upskld_course_pg_card_inner {\n    padding: 16px 16px 20px;\n  }\n\n  .upskld_course_pg_watch_btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .upskld_course_pg_card {\n    animation: none;\n  }\n  .upskld_course_pg_lock_icon,\n  .upskld_course_pg_watch_btn::before {\n    animation: none;\n    transition: none;\n  }\n}\n\n.upskld_course_pg_loading {\n  text-align: center;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #8a8478;\n  padding: 40px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
